import {createSvgIcon} from '@common/icons/create-svg-icon';

export const FormElIcon = createSvgIcon(
  <path d="M 20 2 L 4 2 C 2.894531 2 2 2.894531 2 4 L 2 20 C 2 21.105469 2.894531 22 4 22 L 20 22 C 21.105469 22 22 21.105469 22 20 L 22 4 C 22 2.894531 21.105469 2 20 2 Z M 8 10 L 4 10 L 4 8 L 8 8 Z M 19 10 L 11 10 L 11 8 L 19 8 Z M 20 11 L 10 11 L 10 7 L 20 7 Z M 8 16 L 4 16 L 4 14 L 8 14 Z M 19 16 L 11 16 L 11 14 L 19 14 Z M 20 17 L 10 17 L 10 13 L 20 13 Z "></path>,
  'FormElOutlined',
);
